module.exports = __webpack_public_path__ + "static/Federico_Gaiti_headshot_lores-37a689144dd959a4a8afe539e2f54cde.png";